import { withInterceptorsFromDi, provideHttpClient, withXhr } from '@angular/common/http';
import { enableProdMode, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';

import { provideStore } from '@ngrx/store';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';

import { APP_ROUTES } from './app/routes';
import { ROOT_REDUCERS, metaReducers } from './app/reducers';
import { SentryService } from './app/core/sentry.service';
import { AppErrorHandler } from './app/app-error-handler';
import { httpInterceptorsProvider } from './app/http-interceptors';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        httpInterceptorsProvider,
        provideRouter(APP_ROUTES,
            withPreloading(PreloadAllModules),
            // withViewTransitions(),
            withComponentInputBinding(),
            withInMemoryScrolling({ scrollPositionRestoration: 'top' })
        ),
        provideAnimations(),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideStore(ROOT_REDUCERS, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true
            },
        }),
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler,
            deps: [
                SentryService,
            ],
        },
    ],
}).catch((err) => console.error(err));


